var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-general"},[_vm._t("default",function(){return [_vm._v(" "+_vm._s(_vm.btn_name)+" ")]}),_c('Flash',{ref:"show"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }